import { Flex, H3 } from '@dnb/eufemia';
import {
  email_medium as EmailIcon,
  information_circled as DetailsIcon,
  person as PersonIcon,
  shield_lock_medium as ShieldLockIcon,
  speedometer as SpeedometerIcon,
} from '@dnb/eufemia/icons';
import { ApiType } from '@portals/shared/portal/ApiDto';
import { useOutletContext, useParams } from 'react-router-dom';

import ServiceNowInfoSection from '@/pages/OAuthIntegrationInfoRequesterPage/ServiceNowInfoSection';
import { ApiProviderPageOutletContext } from '@/pages/profile/apps/application/ApiProviderPage';
import { ApiDetailsSection } from '@/pages/profile/apps/application/ApiProviderPage/OverviewTab/components/ApiDetailsSection';

import SectionWithTitle from '../SectionWithTitle';
import AdditionalInformationSection from './components/AdditionalInformationSection';
import DashboardSection from './components/DashboardSection';
import SubscribersSection from './components/SubscribersSection';

export function OverviewTab() {
  const { appId } = useParams();

  const { api, isTeamAdmin, mutate } = useOutletContext<ApiProviderPageOutletContext>();

  const isRestApi = api.type === ApiType.REST;
  const isMcpApi = api.type === ApiType.MCP;

  if (!appId) return;

  const handleApiUpdate = (updatedApi: Partial<typeof api>) => {
    void mutate(
      {
        ...api,
        ...updatedApi,
      },
      false,
    );
  };

  return (
    <Flex.Stack wrap={false}>
      <SectionWithTitle icon={<DetailsIcon />} title="Details">
        <ApiDetailsSection isTeamAdmin={isTeamAdmin} onUpdate={handleApiUpdate} {...api} />
      </SectionWithTitle>

      <SectionWithTitle icon={<PersonIcon />} title="ServiceNow">
        <ServiceNowInfoSection />
      </SectionWithTitle>

      {api.stage !== 'launched' && (
        <SectionWithTitle icon={<SpeedometerIcon />} title="Dashboard">
          <DashboardSection apiId={api.id} appId={appId} />
        </SectionWithTitle>
      )}

      {!isMcpApi && (
        <SectionWithTitle icon={<ShieldLockIcon />} title="Additional information">
          <AdditionalInformationSection api={api} appId={appId} />
        </SectionWithTitle>
      )}

      {isRestApi && (
        <SectionWithTitle icon={<EmailIcon />} title="Subscribers">
          <H3 bottom="small" />
          <SubscribersSection apiId={api.id} />
        </SectionWithTitle>
      )}
    </Flex.Stack>
  );
}
